<template>
  <vue-final-modal
      v-model="showModal"
      @click-outside="modalClose"
      classes="modal-container"
      content-class="modal-content">
    <span class="modal__result-details">
      <span class="report-title">{{ $t('PLEASE_NOTE') }}</span>
      <hr/>
      <span class="play-details">
        <span class="play-time">
          <span>{{ $t('TIME') }}</span>
          <span>{{ getTimeInHoursAndMins(tournament.duration) }}</span>
        </span>
        <span class="total-question">
          <span>{{ $t('TOTAL_QUESTION') }}</span>
          <span>{{ convertNumberToLangWise(tournament.question_count) }}</span>
        </span>
        <span class="total-chance">
          <span>{{ $t('TOTAL_CHANCE') }} </span>
          <span>{{ convertNumberToLangWise(tournament.chances) }}</span>
        </span>
        <span class="chance-finish">
          <span>{{ $t('CHANCE_PLAYED') }} </span>
          <span>{{ convertNumberToLangWise(tournament.played) }}</span>
        </span>
      </span>
    </span>

    <div class="d-flex flex-column justify-content-center align-items-center">
      <argon-button full-width
          color="dark"
          variant="gradient"
          class="my-4"
          style="background: #3EAAFF;" @click="startPlay">{{ $t('START') }}
      </argon-button>
    </div>
  </vue-final-modal>
</template>

<script>
import {VueFinalModal} from 'vue-final-modal';
import ArgonButton from "@/components/ArgonButton.vue";
import {convertEnglishToMayanmar} from "@/helper/numberHelper";

export default {
  name: "PlayNoticeModal",
  props: ['modalShow', 'tournament'],
  components: {
    VueFinalModal,
    ArgonButton,
  },
  data() {
    return {
      showModal: this.modalShow,
      timeDurationInSeconds: 0,
      hoursText: "hrs",
      minsText: "minute",
    }
  },
  created() {

  },
  methods: {
    convertNumberToLangWise(data) {
      let numberDataWithLang = {
        'number': data,
        'lang': this.$store.getters.language
      };
      return convertEnglishToMayanmar(numberDataWithLang);
    },
    modalClose() {
      this.emitter.emit('play-modal-close-event', {'eventContent': false});
    },
    startPlay() {
      this.$router.push({
        name: 'TournamentPlay',
        params: { id: this.tournament.id },
        query: {tournament_type: 'Tournament', tournament_name: this.tournament.caption}
      });
    },
    buyPackage() {
      this.$router.push({path: '/tournament-bundle'});
    },
    getTimeInHoursAndMins(timeInsSeconds) {
      if (timeInsSeconds && timeInsSeconds > 0) {
        const minsTemp = timeInsSeconds / 60;
        let hours = Math.floor(minsTemp / 60);
        const mins = minsTemp % 60;

        if (hours !== 0 && mins !== 0) {
          if (mins >= 59) {
            hours += 1;
            return +`${hours} ${this.hoursText} `;
          } else {
            return `${hours} ${this.hoursText} ${mins.toFixed(0)} ${
                this.minsText
            }`;
          }
        } else if (hours === 0 && mins !== 0) {
          return `${mins.toFixed(0)} ${this.minsText}`;
        } else if (hours !== 0 && mins === 0) {
          return `${hours} ${this.hoursText}`;
        }
      } else {
        return "-";
      }
    },
  }
}
</script>

<style scoped>
:deep .modal-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

:deep .modal-content {
  display: flex;
  flex-direction: column;
  margin-left: 10%;
  margin-right: 10%;
  padding: 1rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.25rem;
  background: #fff;
}
@media only screen and (min-width: 1200px) {
  :deep .modal-content {

    margin-left:19%;
    margin-right:19%;


  }
}

.dark-mode div:deep .modal-content {
  border-color: #2d3748;
  background-color: #1a202c;
}
</style>
